import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import EnTranslations from './en';
import accountsEn from './en/accounts.json';
import analyticsBillsDashboardEn from './en/analytics_bills_dashboard.json';
import analyticsPricesDashboardEn from './en/analytics_prices_dashboard.json';
import analyticsSalesPricesDashboardEn from './en/analytics_sales_prices_dashboard.json';
import authEn from './en/auth.json';
import bookkeepingEn from './en/bookkeeping.json';
import bulkPayEn from './en/bulk_pay.json';
import cardsEn from './en/cards.json';
import cashbackEn from './en/cashback.json';
import cashflowEn from './en/cashflow.json';
import categoriesEn from './en/categories.json';
import categorizationEn from './en/categorization.json';
import chatEn from './en/chat.json';
import consentsEn from './en/consents.json';
import counterpartsEn from './en/counterparts.json';
import countriesEn from './en/countries.json';
import documentsEn from './en/documents.json';
import downloadAppEn from './en/download_app.json';
import emptyStatesEn from './en/empty_states.json';
import f24En from './en/f24.json';
import flowsEn from './en/flows.json';
import inputsEn from './en/inputs.json';
import notFoundEn from './en/not_found.json';
import notificationsEn from './en/notifications.json';
import outstandingEn from './en/outstanding.json';
import paymentRemindersEn from './en/payment_reminders.json';
import paymentsEn from './en/payments.json';
import productCatalogueEn from './en/product_catalogue.json';
import reconciliationsEn from './en/reconciliations.json';
import recurrencesEn from './en/recurrences.json';
import referralEn from './en/referral.json';
import rulesEn from './en/rules.json';
import settingsEn from './en/settings.json';
import sidebarEn from './en/sidebar.json';
import subscriptionsEn from './en/subscriptions.json';
import transactionsEn from './en/transactions.json';
import validationsEn from './en/validations.json';
import ItTranslations from './it';
import accountsIt from './it/accounts.json';
import analyticsBillsDashboardIt from './it/analytics_bills_dashboard.json';
import analyticsPricesDashboardIt from './it/analytics_prices_dashboard.json';
import analyticsSalesPricesDashboardIt from './it/analytics_sales_prices_dashboard.json';
import authIt from './it/auth.json';
import bookkeepingIt from './it/bookkeeping.json';
import bulkPayIt from './it/bulk_pay.json';
import cardsIt from './it/cards.json';
import cashbackIt from './it/cashback.json';
import cashflowIt from './it/cashflow.json';
import categoriesIt from './it/categories.json';
import categorizationIt from './it/categorization.json';
import chatIt from './it/chat.json';
import consentsIt from './it/consents.json';
import counterpartsIt from './it/counterparts.json';
import countriesIt from './it/countries.json';
import documentsIt from './it/documents.json';
import downloadAppIt from './it/download_app.json';
import emptyStatesIt from './it/empty_states.json';
import f24It from './it/f24.json';
import flowsIt from './it/flows.json';
import inputsIt from './it/inputs.json';
import notFoundIt from './it/not_found.json';
import notificationsIt from './it/notifications.json';
import outstandingIt from './it/outstanding.json';
import paymentRemindersIt from './it/payment_reminders.json';
import paymentsIt from './it/payments.json';
import productCatalogueIt from './it/product_catalogue.json';
import reconciliationsIt from './it/reconciliations.json';
import recurrencesIt from './it/recurrences.json';
import referralIt from './it/referral.json';
import rulesIt from './it/rules.json';
import settingsIt from './it/settings.json';
import sidebarIt from './it/sidebar.json';
import subscriptionsIt from './it/subscriptions.json';
import transactionsIt from './it/transactions.json';
import validationsIt from './it/validations.json';

const validateTranslationsKeys = <T extends keyof typeof EnTranslations>(translations: Record<T, string>) =>
  translations;

validateTranslationsKeys(ItTranslations);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      it: {
        analytics_bills_dashboard: analyticsBillsDashboardIt,
        analytics_prices_dashboard: analyticsPricesDashboardIt,
        analytics_sales_prices_dashboard: analyticsSalesPricesDashboardIt,
        accounts: accountsIt,
        auth: authIt,
        bookkeeping: bookkeepingIt,
        categorization: categorizationIt,
        categories: categoriesIt,
        cards: cardsIt,
        cashback: cashbackIt,
        cashflow: cashflowIt,
        chat: chatIt,
        consents: consentsIt,
        counterparts: counterpartsIt,
        countries: countriesIt,
        documents: documentsIt,
        empty_states: emptyStatesIt,
        flows: flowsIt,
        f24: f24It,
        bulk_pay: bulkPayIt,
        inputs: inputsIt,
        not_found: notFoundIt,
        download_app: downloadAppIt,
        notifications: notificationsIt,
        outstanding: outstandingIt,
        settings: settingsIt,
        sidebar: sidebarIt,
        transactions: transactionsIt,
        subscriptions: subscriptionsIt,
        reconciliations: reconciliationsIt,
        recurrences: recurrencesIt,
        translations: ItTranslations,
        payments: paymentsIt,
        validations: validationsIt,
        product_catalogue: productCatalogueIt,
        rules: rulesIt,
        referral: referralIt,
        payment_reminders: paymentRemindersIt,
      },
      en: {
        analytics_bills_dashboard: analyticsBillsDashboardEn,
        analytics_prices_dashboard: analyticsPricesDashboardEn,
        analytics_sales_prices_dashboard: analyticsSalesPricesDashboardEn,
        accounts: accountsEn,
        auth: authEn,
        bookkeeping: bookkeepingEn,
        cards: cardsEn,
        cashback: cashbackEn,
        cashflow: cashflowEn,
        categorization: categorizationEn,
        chat: chatEn,
        categories: categoriesEn,
        consents: consentsEn,
        counterparts: counterpartsEn,
        countries: countriesEn,
        documents: documentsEn,
        empty_states: emptyStatesEn,
        flows: flowsEn,
        f24: f24En,
        bulk_pay: bulkPayEn,
        inputs: inputsEn,
        not_found: notFoundEn,
        download_app: downloadAppEn,
        notifications: notificationsEn,
        outstanding: outstandingEn,
        sidebar: sidebarEn,
        transactions: transactionsEn,
        subscriptions: subscriptionsEn,
        reconciliations: reconciliationsEn,
        recurrences: recurrencesEn,
        settings: settingsEn,
        translations: EnTranslations,
        payments: paymentsEn,
        validations: validationsEn,
        product_catalogue: productCatalogueEn,
        rules: rulesEn,
        referral: referralEn,
        payment_reminders: paymentRemindersEn,
      },
    },
    fallbackLng: 'it',
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['cookie'],
      lookupCookie: 'sibill_locale',
      caches: ['cookie'],
      cookieOptions: {
        httpOnly: false,
        domain: import.meta.env.VITE_COOKIES_DOMAIN,
        secure: true,
      },
    },
    react: {
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'ul', 'li'],
    },
  });

export default i18n;
